// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: keyphrase_boosting.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "keyphrase_boosting";

export interface KeyphrasesBoosting {
  keyphrasesBoosting: KeyphraseBoosting[];
}

export interface KeyphraseBoosting {
  id: string;
  keyphrase: string;
  level: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
}

export interface KeyphraseBoostingCreateKeyphrase {
  id: string;
  keyphrase: string;
  level: string;
}

export interface KeyphraseBoostingUpdateKeyphrase {
  id: string;
  keyphrase?: string | undefined;
  level?: string | undefined;
}

export interface KeyphraseBoostingDeleteKeyphrase {
  id: string;
}

function createBaseKeyphrasesBoosting(): KeyphrasesBoosting {
  return { keyphrasesBoosting: [] };
}

export const KeyphrasesBoosting: MessageFns<KeyphrasesBoosting> = {
  encode(message: KeyphrasesBoosting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.keyphrasesBoosting) {
      KeyphraseBoosting.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyphrasesBoosting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyphrasesBoosting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.keyphrasesBoosting.push(KeyphraseBoosting.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyphrasesBoosting {
    return {
      keyphrasesBoosting: globalThis.Array.isArray(object?.keyphrasesBoosting)
        ? object.keyphrasesBoosting.map((e: any) => KeyphraseBoosting.fromJSON(e))
        : globalThis.Array.isArray(object?.keyphrases_boosting)
        ? object.keyphrases_boosting.map((e: any) => KeyphraseBoosting.fromJSON(e))
        : [],
    };
  },

  toJSON(message: KeyphrasesBoosting): unknown {
    const obj: any = {};
    if (message.keyphrasesBoosting?.length) {
      obj.keyphrasesBoosting = message.keyphrasesBoosting.map((e) => KeyphraseBoosting.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<KeyphrasesBoosting>): KeyphrasesBoosting {
    return KeyphrasesBoosting.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyphrasesBoosting>): KeyphrasesBoosting {
    const message = createBaseKeyphrasesBoosting();
    message.keyphrasesBoosting = object.keyphrasesBoosting?.map((e) => KeyphraseBoosting.fromPartial(e)) || [];
    return message;
  },
};

function createBaseKeyphraseBoosting(): KeyphraseBoosting {
  return {
    id: "",
    keyphrase: "",
    level: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
  };
}

export const KeyphraseBoosting: MessageFns<KeyphraseBoosting> = {
  encode(message: KeyphraseBoosting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.keyphrase !== "") {
      writer.uint32(18).string(message.keyphrase);
    }
    if (message.level !== "") {
      writer.uint32(26).string(message.level);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(42).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(58).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyphraseBoosting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyphraseBoosting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.keyphrase = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyphraseBoosting {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      keyphrase: isSet(object.keyphrase) ? globalThis.String(object.keyphrase) : "",
      level: isSet(object.level) ? globalThis.String(object.level) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
    };
  },

  toJSON(message: KeyphraseBoosting): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.keyphrase !== "") {
      obj.keyphrase = message.keyphrase;
    }
    if (message.level !== "") {
      obj.level = message.level;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<KeyphraseBoosting>): KeyphraseBoosting {
    return KeyphraseBoosting.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyphraseBoosting>): KeyphraseBoosting {
    const message = createBaseKeyphraseBoosting();
    message.id = object.id ?? "";
    message.keyphrase = object.keyphrase ?? "";
    message.level = object.level ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    return message;
  },
};

function createBaseKeyphraseBoostingCreateKeyphrase(): KeyphraseBoostingCreateKeyphrase {
  return { id: "", keyphrase: "", level: "" };
}

export const KeyphraseBoostingCreateKeyphrase: MessageFns<KeyphraseBoostingCreateKeyphrase> = {
  encode(message: KeyphraseBoostingCreateKeyphrase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.keyphrase !== "") {
      writer.uint32(18).string(message.keyphrase);
    }
    if (message.level !== "") {
      writer.uint32(26).string(message.level);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyphraseBoostingCreateKeyphrase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyphraseBoostingCreateKeyphrase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.keyphrase = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyphraseBoostingCreateKeyphrase {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      keyphrase: isSet(object.keyphrase) ? globalThis.String(object.keyphrase) : "",
      level: isSet(object.level) ? globalThis.String(object.level) : "",
    };
  },

  toJSON(message: KeyphraseBoostingCreateKeyphrase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.keyphrase !== "") {
      obj.keyphrase = message.keyphrase;
    }
    if (message.level !== "") {
      obj.level = message.level;
    }
    return obj;
  },

  create(base?: DeepPartial<KeyphraseBoostingCreateKeyphrase>): KeyphraseBoostingCreateKeyphrase {
    return KeyphraseBoostingCreateKeyphrase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyphraseBoostingCreateKeyphrase>): KeyphraseBoostingCreateKeyphrase {
    const message = createBaseKeyphraseBoostingCreateKeyphrase();
    message.id = object.id ?? "";
    message.keyphrase = object.keyphrase ?? "";
    message.level = object.level ?? "";
    return message;
  },
};

function createBaseKeyphraseBoostingUpdateKeyphrase(): KeyphraseBoostingUpdateKeyphrase {
  return { id: "", keyphrase: undefined, level: undefined };
}

export const KeyphraseBoostingUpdateKeyphrase: MessageFns<KeyphraseBoostingUpdateKeyphrase> = {
  encode(message: KeyphraseBoostingUpdateKeyphrase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.keyphrase !== undefined) {
      writer.uint32(18).string(message.keyphrase);
    }
    if (message.level !== undefined) {
      writer.uint32(26).string(message.level);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyphraseBoostingUpdateKeyphrase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyphraseBoostingUpdateKeyphrase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.keyphrase = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.level = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyphraseBoostingUpdateKeyphrase {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      keyphrase: isSet(object.keyphrase) ? globalThis.String(object.keyphrase) : undefined,
      level: isSet(object.level) ? globalThis.String(object.level) : undefined,
    };
  },

  toJSON(message: KeyphraseBoostingUpdateKeyphrase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.keyphrase !== undefined) {
      obj.keyphrase = message.keyphrase;
    }
    if (message.level !== undefined) {
      obj.level = message.level;
    }
    return obj;
  },

  create(base?: DeepPartial<KeyphraseBoostingUpdateKeyphrase>): KeyphraseBoostingUpdateKeyphrase {
    return KeyphraseBoostingUpdateKeyphrase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyphraseBoostingUpdateKeyphrase>): KeyphraseBoostingUpdateKeyphrase {
    const message = createBaseKeyphraseBoostingUpdateKeyphrase();
    message.id = object.id ?? "";
    message.keyphrase = object.keyphrase ?? undefined;
    message.level = object.level ?? undefined;
    return message;
  },
};

function createBaseKeyphraseBoostingDeleteKeyphrase(): KeyphraseBoostingDeleteKeyphrase {
  return { id: "" };
}

export const KeyphraseBoostingDeleteKeyphrase: MessageFns<KeyphraseBoostingDeleteKeyphrase> = {
  encode(message: KeyphraseBoostingDeleteKeyphrase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): KeyphraseBoostingDeleteKeyphrase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseKeyphraseBoostingDeleteKeyphrase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): KeyphraseBoostingDeleteKeyphrase {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: KeyphraseBoostingDeleteKeyphrase): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<KeyphraseBoostingDeleteKeyphrase>): KeyphraseBoostingDeleteKeyphrase {
    return KeyphraseBoostingDeleteKeyphrase.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<KeyphraseBoostingDeleteKeyphrase>): KeyphraseBoostingDeleteKeyphrase {
    const message = createBaseKeyphraseBoostingDeleteKeyphrase();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
